import React from 'react';
import HeadPhoneIcon from '../../images/svg-gcbooks/headphone-icon';
import { useBookAudioPlayer } from '../../context/bookAudioPlayerContext';
import { Link } from 'gatsby';
import { AppContext } from '../../apollo/wrap-root-element';
import { getFullChapterPublicPath, getGcUi, isSpanishGcContent } from '../../constants/spanish-gc';

export default function ReadListenButton({
  audioDetails,
  setShowReadModal,
  chapterUid,
  useFullReadPage = false,
  fullReadPath,
}) {
  const { toggle, audioState, currentAudioId, isLoading, selectedVoice } = useBookAudioPlayer();
  const { currentChapterIndex } = React.useContext(AppContext);
  const isSpanish = isSpanishGcContent(chapterUid);
  const ui = getGcUi(isSpanish ? 'es' : 'en');

  const getSelectedAudioId = () => {
    if (selectedVoice === 'Charlene') return audioDetails?.audioByCharleneId;
    if (selectedVoice === 'Callie') return audioDetails?.audioByCallieId;
    if (selectedVoice === 'Nancy') return audioDetails?.audioByNancyId;
    return audioDetails?.audioByCharleneId;
  };

  const isCurrentAudio = currentAudioId === getSelectedAudioId();
  const readPath =
    fullReadPath ||
    (chapterUid
      ? getFullChapterPublicPath(chapterUid)
      : getFullChapterPublicPath(
          isSpanish ? `gc-es-chapter${currentChapterIndex + 1}` : `gc-chapter${currentChapterIndex + 1}`
        ));

  const getButtonContent = () => {
    if (isLoading && isCurrentAudio) {
      return {
        icon: <HeadPhoneIcon />,
        text: ui.listenLoading || 'Loading...',
      };
    } else if (audioState === 'playing' && isCurrentAudio) {
      return {
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.33333 3.3335H5V16.6668H8.33333V3.3335Z" fill="#FECB04" />
            <path d="M15 3.3335H11.6667V16.6668H15V3.3335Z" fill="#FECB04" />
          </svg>
        ),
        text: ui.listenPause || 'Pause Audio',
      };
    } else if (audioState === 'paused' && isCurrentAudio) {
      return {
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16699 2.5L15.8337 10L4.16699 17.5V2.5Z" fill="#FECB04" />
          </svg>
        ),
        text: ui.listenResume || 'Resume Audio',
      };
    } else {
      return {
        icon: (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.4 0.51999C4.62 0.82999 1 5.01999 1 9.80999V16.5C1 18.16 2.34 19.5 4 19.5H5C6.1 19.5 7 18.6 7 17.5V13.5C7 12.4 6.1 11.5 5 11.5H3V9.78999C3 5.94999 5.96 2.60999 9.79 2.49999C10.7268 2.47187 11.6597 2.63216 12.5333 2.97133C13.407 3.3105 14.2036 3.82166 14.8761 4.47449C15.5485 5.12732 16.083 5.90853 16.4478 6.7718C16.8126 7.63506 17.0004 8.5628 17 9.49999V11.5H15C13.9 11.5 13 12.4 13 13.5V17.5C13 18.6 13.9 19.5 15 19.5H16C17.66 19.5 19 18.16 19 16.5V9.49999C19 4.32999 14.64 0.17999 9.4 0.51999Z"
              fill="#FECB04"
            />
          </svg>
        ),
        text: ui.listen || 'Listen',
      };
    }
  };

  const content = getButtonContent();
  const readIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0003 5.83333C10.0003 4.94928 9.64914 4.10143 9.02401 3.47631C8.39889 2.85119 7.55105 2.5 6.66699 2.5H1.66699V15H7.50033C8.16337 15 8.79925 15.2634 9.26809 15.7322C9.73693 16.2011 10.0003 16.837 10.0003 17.5M10.0003 5.83333V17.5M10.0003 5.83333C10.0003 4.94928 10.3515 4.10143 10.9766 3.47631C11.6018 2.85119 12.4496 2.5 13.3337 2.5H18.3337V15H12.5003C11.8373 15 11.2014 15.2634 10.7326 15.7322C10.2637 16.2011 10.0003 16.837 10.0003 17.5"
        stroke="#FECB04"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="read-listen-button-container">
      {useFullReadPage ? (
        <Link to={readPath} className="tab-button">
          {readIcon}
          <span>{ui.read || 'Read'}</span>
        </Link>
      ) : (
        <div onClick={() => setShowReadModal(true)} role="button" className="tab-button">
          {readIcon}
          <span>{ui.read || 'Read'}</span>
        </div>
      )}

      <button onClick={() => toggle(audioDetails)} className="tab-button" disabled={isLoading && isCurrentAudio}>
        {content.icon}
        <span>{content.text}</span>
      </button>
    </div>
  );
}
